// index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/index.css'; // Ensure this file contains the global CSS rules
import App from './App';
import { QueryProvider } from './providers/QueryProvider';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <QueryProvider>
    <Router>
      <App />
    </Router>
  </QueryProvider>
);